import { UsersStatus } from "src/components/Session/withAuthorization";

export const SESSION_EVENTS = {
  AUTH_USER_SET: "AUTH_USER_SET",
  ROLES_SET: "ROLES_SET",
  ORG_ID_SET: "ORG_ID_SET",
  ORG_CONFIG_SET: "ORG_ID_CONFIG",
  ORG_ID_AND_ROLES_SET: "ORG_ID_AND_ROLES_SET",
  WELCOME_MSG_SET: "WELCOME_MSG_SET"
}

export interface IRoles {
  admin: boolean;
  owner: boolean;
}

export interface ISessionState {
  authUser: firebase.User;
  roles: IRoles;
  orgId: string;
  orgConfig: any;
  showWelcomeMessage: boolean;
  usersStatus: UsersStatus;
}

const INITIAL_STATE: ISessionState = {
  authUser: null,
  roles: null,
  orgId: null,
  orgConfig: null,
  showWelcomeMessage: false,
  usersStatus: {}
};

const applySetAuthUser = (state: any, action: any) => ({
  ...state,
  authUser: action.authUser.authUser,
});

const applySetRoles = (state: any, action: any) => ({
  ...state,
  roles: action.roles,
});

const applySetOrgId = (state: any, action: any) => ({
  ...state,
  orgId: action.orgId,
});

const applySetOrgConfig = (state: any, action: any) => ({
  ...state,
  orgConfig: action.orgConfig,
});

const applySetOrgIdAndRoles = (state: any, action: any) => ({
  ...state,
  orgConfig: action.orgConfig,
  roles: action.roles,
  orgId: action.orgId,
  usersStatus: action.usersStatus,
})

const applySetWelcomeMsg = (state: any, action: any) => ({
  ...state,
  showWelcomeMessage: action.show,
})


export function sessionReducer(state = INITIAL_STATE, action: any) {
  switch (action.type) {
    case SESSION_EVENTS.AUTH_USER_SET: {
      return applySetAuthUser(state, action);
    }
    case SESSION_EVENTS.ROLES_SET: {
      return applySetRoles(state, action);
    }
    case SESSION_EVENTS.ORG_ID_SET: {
      return applySetOrgId(state, action);
    }
    case SESSION_EVENTS.ORG_CONFIG_SET: {
      return applySetOrgConfig(state, action);
    }
    case SESSION_EVENTS.ORG_ID_AND_ROLES_SET: {
      return applySetOrgIdAndRoles(state, action);
    }
    case SESSION_EVENTS.WELCOME_MSG_SET: {
      return applySetWelcomeMsg(state, action);
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/session.ts